//separated into different file because of a circular dependency caused otherwise
export const IS_LOADING = "itemsSearchBarcode/IS_LOADING";
export const SUCCESS = "itemsSearchBarcode/SUCCESS";
export const HAS_ERROR = "itemsSearchBarcode/HAS_ERROR";
export const QUERY_STRING_UPDATE = "itemsSearchBarcode/QUERY_STRING_UPDATE";
export const CLEAR_SEARCH = "itemsSearchBarcode/CLEAR_SEARCH";
